import { FC, useMemo } from 'react';
import { Modal as QcsModal, useTheme } from '@mui/material';

import { QcsModalBox } from '../../../common/basic/QcsModalBox';
import { SectionHeader } from '../../../common/SectionHeader';
import { GridList } from '../../../common/grid/GridList';
import { QcsTableCell } from '../../../common/basic/QcsTableCell';
import { getLangNameObj } from '../../../../utils/format';
import { useInvitation } from './invitationFunctions';
import { SafetyEquipmentType } from '@api/models/enums/SafetyEquipmentType';
import { SafetyEquipmentDto } from '@api/models/invitation/SafetyEquipmentDto';
import { InvitedPersonDto } from '@api/models/invitation/InvitedPersonDto';

interface Props {
  data?: InvitedPersonDto;
  onClose: () => void;
}

export const InvitedPersonsSafetyEquipmentModal: FC<Props> = ({
  data,
  onClose,
}) => {
  const { t, i18n, invitation } = useInvitation();

  const theme = useTheme();

  const list = useMemo(
    () =>
      !data
        ? []
        : ([] as SafetyEquipmentDto[]).concat(
            ...(invitation.workplaces ?? [])
              .filter((workplace) =>
                data.workplaces.some((dw) => dw.id === workplace.workplace?.id)
              )
              .map((workplace) => workplace?.safetyEquipments ?? [])
          ),
    [invitation.workplaces, data]
  );

  const handleRenderData = (item: SafetyEquipmentDto) => {
    return (
      <>
        <QcsTableCell>{getLangNameObj(i18n, item)}</QcsTableCell>
        <QcsTableCell
          sx={{
            color: item.type === SafetyEquipmentType.Owned ? theme.palette.warning.main : undefined,
          }}
        >
          {t('safetyEquipment.types.' + item.type)}
        </QcsTableCell>
      </>
    );
  };

  return (
    <QcsModal open={!!data} onClose={onClose}>
      <QcsModalBox>
        <SectionHeader title="invitation.persons.safetyEquipmentTitle" />
        <GridList<SafetyEquipmentDto>
          headers={[
            { captionStr: 'invitation.persons.safetyEquipmentName' },
            { captionStr: 'invitation.persons.safetyEquipmentType' },
          ]}
          data={list}
          renderData={handleRenderData}
          search={false}
          hidePagination={true}
        />
      </QcsModalBox>
    </QcsModal>
  );
};
